var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3143 4.47012C15.7764 4.70216 15.191 4.86915 14.5881 4.93419C15.2141 4.5623 15.6828 3.97477 15.9064 3.28184C15.319 3.63128 14.6755 3.87631 14.0045 4.00606C13.724 3.70623 13.3848 3.46736 13.008 3.30436C12.6312 3.14135 12.2248 3.05769 11.8143 3.0586C10.1531 3.0586 8.81719 4.40509 8.81719 6.05743C8.81719 6.28946 8.84531 6.52149 8.89102 6.74473C6.40371 6.61466 4.18535 5.42637 2.71055 3.60704C2.44182 4.06603 2.301 4.58865 2.30273 5.12051C2.30273 6.16114 2.83184 7.07872 3.63867 7.61837C3.16319 7.59964 2.69884 7.46895 2.2834 7.23692V7.27383C2.2834 8.73106 3.31348 9.93868 4.68633 10.2164C4.42856 10.2834 4.16339 10.3176 3.89707 10.3184C3.70195 10.3184 3.51738 10.299 3.33105 10.2727C3.71074 11.4609 4.81641 12.324 6.13301 12.3522C5.10293 13.159 3.8127 13.6336 2.41172 13.6336C2.16035 13.6336 1.92832 13.6248 1.6875 13.5967C3.01641 14.4492 4.59316 14.9414 6.29121 14.9414C11.8037 14.9414 14.8201 10.3746 14.8201 6.41075C14.8201 6.28067 14.8201 6.15059 14.8113 6.02051C15.3949 5.59337 15.9064 5.06426 16.3143 4.47012Z",
    fill: "#FC4C02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.8c8fc7825bf7db9d383b00be4b14c653.svg";
export { ForwardRef as ReactComponent };